module.exports = {"wheat":{"volume":0.96,"baseWaste":2,"baseMoisture":14,"critWaste":5,"critMoisture":20},"rape":{"volume":0.8,"baseWaste":3,"baseMoisture":8,"critWaste":10,"critMoisture":18},"soy":{"volume":0.86,"baseWaste":3,"baseMoisture":12,"critWaste":10,"critMoisture":18},"corn":{"volume":0.88,"baseWaste":2,"baseMoisture":14,"critWaste":10,"critMoisture":35},"sunflower":{"volume":0.52,"baseWaste":3,"baseMoisture":8,"critWaste":10,"critMoisture":16},"None":{"volume":0,"baseWaste":0,"baseMoisture":0,"critWaste":0,"critMoisture":0}}


//////////////////
// WEBPACK FOOTER
// ./src/shared/stores/cultureSettings.json
// module id = 6
// module chunks = 0